import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BrandMaintenanceRoutingModule } from './brand-maintenance-routing.module';
import { BrandMaintenanceComponent } from './brand-maintenance.component';
import { BrandMaintenanceFormComponent } from './brand-maintenance-form/brand-maintenance-form.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { MaintenanceListModule } from 'src/app/core/custom-modules/maintenance-list/maintenance-list.module';
import { MaintenanceDetailModule } from 'src/app/core/custom-modules/maintenance-detail/maintenance-detail.module';
import { BrandMaintenanceFilterComponent } from './brand-maintenance-filter/brand-maintenance-filter.component';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    MaintenanceListModule,
    MaintenanceDetailModule,
    BrandMaintenanceRoutingModule
  ],
  declarations: [BrandMaintenanceComponent, BrandMaintenanceFormComponent, BrandMaintenanceFilterComponent],
  entryComponents: [BrandMaintenanceFilterComponent]
})
export class BrandMaintenanceModule { }
